<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_19388_9344)">
      <path
        d="M18.6355 14.157L27.3734 3.99988H25.3028L17.7156 12.8192L11.6558 3.99988H4.6665L13.8302 17.3362L4.6665 27.9876H6.73723L14.7495 18.6741L21.1491 27.9876H28.1384L18.635 14.157H18.6355ZM15.7993 17.4537L14.8708 16.1257L7.48335 5.55869H10.6639L16.6257 14.0866L17.5541 15.4146L25.3038 26.4996H22.1233L15.7993 17.4542V17.4537Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_19388_9344">
        <rect
          width="23.4719"
          height="24"
          fill="white"
          transform="translate(4.6665 3.99988)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
